import { equalWithinTolerance } from './equalsWithinTolerance';

const distanceTolerance = 0.03125;

export function distanceEquals(distance1: number, distance2: number) {
  return equalWithinTolerance(distance1, distance2, distanceTolerance);
}
export function distanceGreaterThanOrEqual(distance1: number, distance2: number) {
  return distance1 >= distance2 || distanceEquals(distance1, distance2);
}
export function distanceLessThanOrEqual(distance1: number, distance2: number) {
  return distance1 <= distance2 || distanceEquals(distance1, distance2);
}
export function distanceGreaterThan(distance1: number, distance2: number) {
  return !distanceLessThanOrEqual(distance1, distance2);
}
export function distanceLessThan(distance1: number, distance2: number) {
  return !distanceGreaterThanOrEqual(distance1, distance2);
}

export function distanceComparator(distance1: number, distance2: number) {
  return distanceEquals(distance1, distance2) ? 0 : distance1 - distance2;
}

export function convertFeetToInches(feet: number) {
  return feet * 12;
}
export function convertInchesToFeet(inches: number) {
  return inches / 12;
}
